module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0",
      "min-height": "100%"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-cell-group', [_c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "value": _vm.formData.extra_saiqu.length ? _vm.formData.extra_saiqu[0].name : '',
      "autosize": "",
      "type": "textarea",
      "input-align": "right",
      "label": "选择赛区",
      "placeholder": "选择执裁的赛区"
    },
    on: {
      "click": function($event) {
        _vm.showSaiquPicker = true
      }
    }
  }), _vm._v(" "), _c('SaiquPicker', {
    attrs: {
      "show": _vm.showSaiquPicker,
      "limit": 1,
      "value": _vm.formData.extra_saiqu,
      "defaultValue": _vm.formData.extra_saiqu
    },
    on: {
      "onChange": _vm.onSaiquChange,
      "onClose": function($event) {
        _vm.showSaiquPicker = false
      },
      "onConfirm": _vm.onSaiquConfirm
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入裁判长姓名'
      }],
      "error-message-align": "right",
      "label": "裁判长姓名",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入裁判长姓名"
    },
    model: {
      value: (_vm.formData.caipan_admin_name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "caipan_admin_name", $$v)
      },
      expression: "formData.caipan_admin_name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入姓名'
      }],
      "error-message-align": "right",
      "label": "执裁裁判名称",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "label": "日期",
      "input-align": "right",
      "error-message-align": "right",
      "placeholder": "请选择日期",
      "rules": [{
        required: true,
        message: '请选择日期'
      }]
    },
    on: {
      "click": function($event) {
        _vm.showDate = true
      }
    },
    model: {
      value: (_vm.formData.date),
      callback: function($$v) {
        _vm.$set(_vm.formData, "date", $$v)
      },
      expression: "formData.date"
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showDate),
      callback: function($$v) {
        _vm.showDate = $$v
      },
      expression: "showDate"
    }
  }, [_c('van-datetime-picker', {
    attrs: {
      "type": "date",
      "title": "选择年月日",
      "min-date": _vm.minDate,
      "max-date": _vm.maxDate
    },
    on: {
      "confirm": _vm.onDateConfirm,
      "cancel": function($event) {
        _vm.showDate = false
      }
    },
    model: {
      value: (_vm.currentDate),
      callback: function($$v) {
        _vm.currentDate = $$v
      },
      expression: "currentDate"
    }
  })], 1), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "执裁记录照片",
      "value": _vm.formData.pic.length + '/9'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.pic,
      "limit": 9,
      "name": 'pic'
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "100px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n        提交申请\n      ")])], 1)], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c413861","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/sai/SaiScoreCaipanApply.vue
// module id = 2373
// module chunks = 0